var m = require('mithril');
var layout = require('../layout/layout');
var login = require('./login');
var users = require('./components/users');
var editUser = require('./components/editUser');
var groups = require('./components/groups');
var groupDetail = require('./components/groupDetail');
var profile = require('./profile');
var usersOnline = require('../usersOnline/usersOnline');

var routes = {
  '/login': login,
  // Old bookmarks share the same configuration-aware login screen: local
  // runtimes retain password/email-link sign-in, while Cloud runtimes use the
  // Cloud handoff.
  '/locallogin': login,
  '/profile/:rid': {
    view : function () {
      return m(layout, m(profile));
    }
  },
  '/users': {
    view: function () {
      return m(layout, m(users));
    }
  },
  '/user/:rid': {
    view: function () {
      return m(layout, m(editUser));
    }
  },
  '/groups': {
    view: function () {
      return m(layout, m(groups));
    }
  },
  '/users/online': {
    view: function () {
      return m(layout, m(usersOnline));
    }
  },
  '/group/:id': {
    view: function () {
      return m(layout, m(groupDetail));
    }
  }
};

module.exports = routes;
